<script lang="ts">
    import { resize } from 'svelte-resize-observer-action';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();
    const onResize = entry => dispatch('resize', entry.contentRect);
</script>

<div
    class="root absolute top-[var(--ui-screen-top)] flex h-[var(--ui-screen-height)] w-full flex-col items-center justify-center overflow-hidden"
    use:resize={onResize}
>
    <slot />
</div>
